// extracted by css-extract-rspack-plugin
export default {"container":"EmployeeAchievements_container__S-gd+"};